import React from 'react';

export default function Footer() {
  return (
    <footer className="p-4 bg-gray-900 text-white text-center">
      <p>© {new Date().getFullYear()} Abin Shoby</p>
    </footer>
  );
}
